import { Box, Stack } from "@mui/material";
import CardDsfrContext from "components/CardDsfrContext";
import DSFRListContext from "components/DSFRListContext";
import HelpAndShare from "components/LayoutFront/HelpAndShare";
import Wrapper from "components/LayoutFront/Wrapper";
import TemplateBanner from "components/templatesComponents/TemplateBanner";
import PropTypes from "prop-types";
import React, { useMemo } from "react";

const KnowEverythingDsfr = (props) => {
  const { page = {} } = props;
  const { contents, shortDescription, template, title } = page;
  const { articlesTitle, highlighted, dynamicPart } = contents;
  let { articles = [] } = contents;

  if (!Array.isArray(articles)) {
    articles = [articles];
  }

  const bo = useMemo(() => typeof title === "object", [title]);

  const cardDsfrContextHighlightedValue = useMemo(
    () => ({ hasGreyBackground: true, highlighted: true, showDescription: true }),
    [],
  );
  const cardDsfrContextArticlesValue = useMemo(() => ({ hasGreyBackground: true }), []);

  const dsfrListContextHighlightedValue = useMemo(() => ({ xs: 12, sm: 12, lg: 12 }), []);
  const dsfrListContextArticlesValue = useMemo(() => ({ xs: 12, sm: 6, lg: 4 }), []);

  return (
    <>
      <TemplateBanner bo={bo}>
        <Stack sx={{ flexGrow: 1 }}>
          <h1>{title}</h1>
          {shortDescription && <p className="fr-text--xl">{shortDescription}</p>}
        </Stack>
      </TemplateBanner>
      <Wrapper sx={{ "& h2": { mt: 6, mb: 0 }, "& h3": { mb: 0 } }}>
        <Box sx={{ px: { xs: 2, lg: 0 }, "& > h2": { mb: 1 }, "& button": { my: 2 } }}>
          {articlesTitle && <h2>{articlesTitle}</h2>}
          <DSFRListContext.Provider value={dsfrListContextHighlightedValue}>
            <CardDsfrContext.Provider value={cardDsfrContextHighlightedValue}>{highlighted}</CardDsfrContext.Provider>
          </DSFRListContext.Provider>
          <DSFRListContext.Provider value={dsfrListContextArticlesValue}>
            <CardDsfrContext.Provider value={cardDsfrContextArticlesValue}>{articles}</CardDsfrContext.Provider>
          </DSFRListContext.Provider>
        </Box>
        {dynamicPart}
        <HelpAndShare alwaysDisplayShare template={template} />
      </Wrapper>
    </>
  );
};

KnowEverythingDsfr.propTypes = {
  page: PropTypes.shape(),
};

export default KnowEverythingDsfr;
